export default __webpack_public_path__ + "assets/img/job-card-cover.png";